import { useUseCase } from "../../../context/UseCaseContext/UseCaseContext";
import styles from "./UsecaseMenu.module.css";
import useCase2NameMapping from "./UsecaseMapping";

interface Props {
  disableUseCaseButton: boolean;
}

const UsecaseMenu = ({ disableUseCaseButton }: Props) => {
  const { useCases, selectedUseCase, setSelectedUseCase, loading } =
    useUseCase();

  const useCaseList = Object.values(useCases);

  if (loading && useCaseList.length === 0) {
    return <div>Loading use cases…</div>;
  }

  return (
    <div className={styles.buttonList}>
      {useCaseList.map((useCase) => {
        const isActive = selectedUseCase === useCase.name;
        const isBeta = BETA_USE_CASES.includes(useCase.name);

        return (
          <button
            key={useCase.id}
            onClick={() => setSelectedUseCase(useCase.name)}
            className={`${styles.useCaseButton} ${
              isActive ? styles.active : ""
            }`}
            disabled={disableUseCaseButton}
          >
            {/* Map to pretty name if configured */}
            {useCase2NameMapping.get(useCase.name) ?? useCase.name}

            {isBeta && <span className={styles.betaTag}>BETA</span>}
          </button>
        );
      })}
    </div>
  );
};

// Use cases shown with a BETA tag in the menu.
const BETA_USE_CASES: string[] = [];

export default UsecaseMenu;
